<button mat-stroked-button type="button" class="btn boton-imagen" (click)="initiateGoogleLogin()">
    <div class="image-container">
        <img src="/assets/google.webp" width="20" />
        <p>Sign in with Google</p>
    </div>
</button>
